export default __webpack_public_path__ + "static/media/Barlow-Medium.d4afdc13.ttf";